export default "/_next/static/images/use-cases--target-shooting-legacy-15ee6ccb9d7c1cdbc09b578f67a41a43.svg";